'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleTextField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsBrowser = require('@bibliocommons/utils-browser');

var _sharedFieldErrorWrapper = require('@bibliocommons/shared-field-error-wrapper');

var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessibleTextField = exports.AccessibleTextField = function (_BcReactComponent) {
  _inherits(AccessibleTextField, _BcReactComponent);

  function AccessibleTextField(props) {
    _classCallCheck(this, AccessibleTextField);

    var _this = _possibleConstructorReturn(this, (AccessibleTextField.__proto__ || Object.getPrototypeOf(AccessibleTextField)).call(this, props));

    _this.bindAll('handleChange', 'handlePaste', 'renderRemainingCount', 'updateRemainingCount');
    var value = _this.props.value || '';
    _this.state = {
      remainingCount: _this.props.maxLength - value.length
    };
    return _this;
  }

  _createClass(AccessibleTextField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // for testing purposes.
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      var value = this._textInput.value;
      if (this.props.maxLength) {
        this.updateRemainingCount(value.length);
      }
      if (this.props.handleChange) {
        this.props.handleChange(value);
      }
    }
  }, {
    key: 'handlePaste',
    value: function handlePaste(e) {
      var value = (0, _utilsBrowser.getTextFromPasteEvent)(e);
      if (this.props.maxLength) {
        this.updateRemainingCount(value.length);
      }
      if (this.props.handlePaste) {
        this.props.handlePaste(value);
      }
    }
  }, {
    key: 'updateRemainingCount',
    value: function updateRemainingCount(charactersUsed) {
      this.setState({
        remainingCount: this.props.maxLength - charactersUsed
      });
    }
  }, {
    key: 'renderRemainingCount',
    value: function renderRemainingCount() {
      if (!this.props.maxLength) {
        return null;
      }
      return _react2.default.createElement(
        'small',
        { className: 'sr-only remaining-characters', 'aria-live': 'polite', 'aria-atomic': 'true' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'characters_remaining', values: {
            remaining: this.state.remainingCount
          } })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'clearfix' },
        _react2.default.createElement('input', {
          id: this.props.id,
          type: this.props.type,
          className: 'cp-accessible-text-field form-control ' + this.props.className,
          ref: function ref(el) {
            _this2._textInput = el;
          },
          'aria-labelledby': this.props.labelledById,
          'aria-describedby': this.props.describedById,
          disabled: this.props.disabled,
          onChange: this.handleChange,
          onPaste: this.handlePaste,
          onFocus: this.props.handleFocus,
          onBlur: this.props.handleBlur,
          maxLength: this.props.maxLength,
          name: this.props.name,
          pattern: this.props.pattern,
          placeholder: this.props.placeholder,
          readOnly: this.props.readOnly,
          required: this.props.required,
          value: this.props.value,
          autoFocus: this.props.focus,
          'data-test-id': this.props.testId }),
        this.renderRemainingCount()
      );
    }
  }]);

  return AccessibleTextField;
}(_baseBcReactComponent2.default);

AccessibleTextField.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  errorKey: _react.PropTypes.string.isRequired,
  describedById: _react.PropTypes.string.isRequired,
  disabled: _react.PropTypes.bool,
  handleChange: _react.PropTypes.func,
  handlePaste: _react.PropTypes.func,
  handleBlur: _react.PropTypes.func,
  handleFocus: _react.PropTypes.func,
  labelledById: _react.PropTypes.string.isRequired,
  maxLength: _react.PropTypes.number,
  name: _react.PropTypes.string,
  pattern: _react.PropTypes.string,
  type: _react.PropTypes.string,
  focus: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  readOnly: _react.PropTypes.bool,
  required: _react.PropTypes.bool,
  value: _react.PropTypes.string,
  testId: _react.PropTypes.string
};

AccessibleTextField.defaultProps = {
  type: 'text'
};

exports.default = (0, _sharedFieldErrorWrapper2.default)(AccessibleTextField);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/accessibility/text-field/lib/components/AccessibleTextField.component.js
// module id = 356
// module chunks = 0 1 4